export default __webpack_public_path__ + "static/media/add-resource-disabled.0e25f9a7.svg";